import { jsx } from 'react/jsx-runtime';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useCallback } from 'react';
import { DayText } from './components/base/day.mjs';
import { MonthViewHeader } from './components/base/month.mjs';
import Calendar from './components/Calendar.mjs';
import DatePickerClear from './components/Clear.mjs';
import MonthCalendar from './components/MonthCalendar/index.mjs';
import DatePickerContent from './components/Content.mjs';
import DatePickerController from './components/Controller.mjs';
import DatePickerMonthController from './components/MonthController.mjs';
import DatePickerDivider from './components/Divider.mjs';
import DatePickerInput from './components/Input.mjs';
import DatePickerMonthInput from './components/MonthInput.mjs';
import ModeToggleSwitch from './components/ModeToggleSwitch.mjs';
import ModeToggleTrigger from './components/ModeToggleTrigger.mjs';
import { DatePickerProvider } from './context/datePickerContext.mjs';

const DatePickerImpl = (props) => {
  const {
    children,
    __scopeDatePicker,
    onChangeMode,
    disabled = false,
    minDate,
    maxDate,
    excludeDates,
    includeDateIntervals,
    openToDate,
    ...rest
  } = props;
  const [selectedDate = null, setSelectedDate] = useControllableState({
    prop: rest.mode === "single" ? rest.selectedDate : null,
    defaultProp: rest.mode === "single" ? rest.defaultDate : null,
    onChange: rest.mode === "single" ? rest.onDateChange : () => {
    }
  });
  const [startDate = null, setStartDate] = useControllableState({
    prop: rest.mode === "range" ? rest.startDate : null,
    defaultProp: rest.mode === "range" ? rest.defaultStartDate : null,
    onChange: rest.mode === "range" ? rest.onStartDateChange : () => {
    }
  });
  const [endDate = null, setEndDate] = useControllableState({
    prop: rest.mode === "range" ? rest.endDate : null,
    defaultProp: rest.mode === "range" ? rest.defaultEndDate : null,
    onChange: rest.mode === "range" ? rest.onEndDateChange : () => {
    }
  });
  const clearSelected = useCallback(() => {
    if (rest.mode === "single") {
      setSelectedDate(null);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  }, [rest.mode, setEndDate, setSelectedDate, setStartDate]);
  return /* @__PURE__ */ jsx(
    DatePickerProvider,
    {
      mode: rest.mode,
      clearSelected,
      onChangeMode,
      disabled,
      selectedDate,
      onDateChange: setSelectedDate,
      startDate,
      endDate,
      onStartDateChange: setStartDate,
      onEndDateChange: setEndDate,
      scope: __scopeDatePicker,
      minDate,
      maxDate,
      excludeDates,
      includeDateIntervals,
      openToDate,
      children
    }
  );
};
const DatePicker = DatePickerImpl;
DatePicker.Calendar = Calendar;
DatePicker.MonthCalendar = MonthCalendar;
DatePicker.CalendarHeader = MonthViewHeader;
DatePicker.DayContent = DayText;
DatePicker.Controller = DatePickerController;
DatePicker.ClearButton = DatePickerController.ClearButton;
DatePicker.MonthController = DatePickerMonthController;
DatePicker.ModeToggleSwitch = ModeToggleSwitch;
DatePicker.ModeToggleTrigger = ModeToggleTrigger;
DatePicker.Divider = DatePickerDivider;
DatePicker.Content = DatePickerContent;
DatePicker.Input = DatePickerInput;
DatePicker.MonthInput = DatePickerMonthInput;
DatePicker.Clear = DatePickerClear;

export { DatePicker as default };
//# sourceMappingURL=DatePicker.mjs.map
